import React from 'react';
import { IconButton, IconButtonProps } from '@mui/material';
// ICONS
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
// HELPERS
import { isMobileScreen } from '../../../helper/Mobile';

const BackButton: React.FC<IconButtonProps> = ({ children, ...props }) => {
  // BOOLEANS
  const isMobile = isMobileScreen();

  return (
    <div>
      <IconButton {...props}>
        {isMobile ? (
          <ArrowBackIosNewIcon sx={{ position: 'relative', left: '-2px' }} />
        ) : (
          <ArrowBackIcon />
        )}
      </IconButton>
    </div>
  );
};

export default BackButton;
